/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnav_ChangesInputs */

const en_portalnav_changes = /** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const ar_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const he_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const ur_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const es_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const fr_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const de_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const pt_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const hi_portalnav_changes = en_portalnav_changes;

/** @type {(inputs: Portalnav_ChangesInputs) => LocalizedString} */
const bn_portalnav_changes = en_portalnav_changes;

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Portalnav_ChangesInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnav_changes = /** @type {((inputs?: Portalnav_ChangesInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnav_ChangesInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnav_changes(inputs)
	if (locale === "he") return he_portalnav_changes(inputs)
	if (locale === "ur") return ur_portalnav_changes(inputs)
	if (locale === "es") return es_portalnav_changes(inputs)
	if (locale === "fr") return fr_portalnav_changes(inputs)
	if (locale === "de") return de_portalnav_changes(inputs)
	if (locale === "pt") return pt_portalnav_changes(inputs)
	if (locale === "hi") return hi_portalnav_changes(inputs)
	if (locale === "bn") return bn_portalnav_changes(inputs)
	return /** @type {LocalizedString} */ ("Changes")
});